import { Input } from "@progress/kendo-react-inputs";
import { FieldWrapper, type FieldRenderProps } from "@progress/kendo-react-form";
import type { HTMLInputAutoCompleteAttribute } from "react";

export type AppFieldRenderProps = FieldRenderProps & {
    autoComplete?: HTMLInputAutoCompleteAttribute | undefined;
};

const FormInputField = (fieldRenderProps: AppFieldRenderProps) => {
    const { validationMessage, touched, id, valid, type, autoComplete, label, ...inputProps } = fieldRenderProps;
    const showValidationMessage = touched && validationMessage;

    return (
        <FieldWrapper>
            <label htmlFor={id}>{label}</label>
            <Input id={id} type={type} autoComplete={autoComplete} valid={valid} ariaDescribedBy={`${id}_error`} {...inputProps} />
            {showValidationMessage && (
                <div id={`${id}_error`} className="k-form-error">
                    {validationMessage}
                </div>
            )}
        </FieldWrapper>
    );
};

export default FormInputField;
